module.exports = __webpack_public_path__ + "media/packs/images/cost/thc-d890d7ad7ec872374df52edba5ea6689.svg";